// Client V2 common imports
const { DISMISS_OPEN_IN_APP } = require('client-v2/common/containers/open-in-app-button/actions')
// Sibling imports
const {
  BROWSER_IS_ACTUALLY_AN_IPAD,
  UPDATE_EXTENSION_INSTALLED
} = require('./actions')
const EnvironmentRecord = require('./record')

// eslint-disable-next-line complexity
function environmentReducer(
  state = new EnvironmentRecord(),
  { type, payload }
) {
  switch (type) {
    case BROWSER_IS_ACTUALLY_AN_IPAD:
      return state.mergeDeep({
        browser: {
          ios: true,
          isDesktop: false,
          isTablet: true,
          tablet: true
        }
      })
    case DISMISS_OPEN_IN_APP:
      return state.set('openInAppDismissed', true)
    case UPDATE_EXTENSION_INSTALLED:
      return state.set('extensionInstalled', payload)
    default:
      return state
  }
}

module.exports = environmentReducer
